// extracted by mini-css-extract-plugin
export var layoutContainer = "_5s-0";
export var layoutContainerNoRounding = "_5s-6";
export var layoutContainerOpen = "_5s-5";
export var layoutContainerResizing = "_5s-1";
export var mainContent = "_5s-2";
export var resizeDivider = "_5s-3";
export var slidePanel = "_5s-4";